import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';


const useStyles = makeStyles(theme => ({
    root: focused => ({
        backgroundColor: focused ? theme.palette.admin.light : theme.palette.admin.main,
        '&:hover': {
            backgroundColor: focused ? theme.palette.admin.light : theme.palette.admin.dark,
        },
    }),
}));

const ParametersButtonKey = ({ focused, keyName, onClick }) => {
    const classes = useStyles(focused);

    return (
        <Box
            className={`parameters-explorer-button ${classes.root}`}
            onClick={()=>onClick()}
        >
            <Box>
                { keyName }
            </Box>
        </Box>
    );
};

export default ParametersButtonKey;